function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Campaign Monitor");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "mark-color",
  d: "M1409.51,485.21a43.11,43.11,0,0,0-60.08-10.56L291.23,1215.59A43,43,0,0,0,326.51,1234l.06,0v0H1374.2a43.12,43.12,0,0,0,43.12-43.14V509.26a43,43,0,0,0-7.81-24.05",
  transform: "translate(-283.46 -466.8)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "mark-color",
  d: "M351.36,474.61a43.15,43.15,0,0,0-67.9,34.64l0,682.86L787.28,779.42Z",
  transform: "translate(-283.46 -466.8)"
});

const SvgCampainMonitor = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "campain_monitor_logo",
    viewBox: "0 0 1133.86 767.19",
    width: 22,
    height: 16,
    fill: "white",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCampainMonitor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/campain_monitor.de081b98.svg";
export { ForwardRef as ReactComponent };